import React, { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, storeActions } from '../../store'

import { Mode, RecognitionState } from '../../models/enums'
import Counter from './Utils/Counter'

const CounterAttachment = (): JSX.Element => {
  const dispatch = useDispatch()
  const translation = useSelector((state: RootState) => state.localeReducer.currentTranslations)
  const placeHolder = useSelector((state: RootState) => state.retorikReducer.sendBoxPlaceHolder)
  const delay = useSelector((state: RootState) => state.retorikReducer.submitDelayBeforeSendingMessage)
  const mode = useSelector((state: RootState) => state.speechReducer.mode)
  const speechInterims = useSelector((state: RootState) => state.speechReducer.lastRecognitionInterim)
  const recognitionState = useSelector((state: RootState) => state.speechReducer.activeRecognitionState)

  const [displayCounter, setDisplayCounter] = useState<boolean>(false)
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    setDisplayCounter(false)
  }, [placeHolder, delay])

  useEffect(() => {
    if (delay && recognitionState === RecognitionState.Closing && speechInterims) {
      setDisplayCounter(true)
      timerRef.current = setTimeout(() => {
        dispatch(storeActions.directline.sendMessage({ text: speechInterims }))
        dispatch(storeActions.speech.setActiveRecognitionState(RecognitionState.Closed))
      }, delay * 1000)
    }

    return () => {
      timerRef.current && clearTimeout(timerRef.current)
    }
  }, [delay, speechInterims, recognitionState])

  const handleButtonClick = (): void => {
    timerRef.current && clearTimeout(timerRef.current)
    dispatch(storeActions.speech.setActiveRecognitionState(RecognitionState.Closed))
    dispatch(storeActions.speech.setMode(Mode.text))
  }

  return mode === Mode.vocal && (recognitionState === RecognitionState.Closing || recognitionState === RecognitionState.Listening) ? (
    <div className='rf-w-full rf-h-full rf-p-4 rf-pb-8 rf-flex rf-flex-col rf-items-center rf-bg-cardFrameBackground rf-gap-4 rf-rounded'>
      {/* Placeholder as title */}
      {placeHolder && <div className='rf-w-full rf-subtitle-size-auto rf-text-center rf-text-cardFrameText rf-font-bold'>{placeHolder}</div>}

      {/* Correction button */}
      {displayCounter ? (
        /* Counter + button */
        <React.Fragment>
          {delay && <Counter delay={delay} />}
          <button className='rf-card-button' onClick={handleButtonClick}>
            {translation.anghello.correct}
          </button>
        </React.Fragment>
      ) : (
        <div className='rf-w-full rf-text-medium-size-auto rf-text-center rf-text-cardButtonTextDefault'>{translation.anghello.listening}</div>
      )}
    </div>
  ) : (
    <React.Fragment />
  )
}

export default CounterAttachment
